module.exports = __webpack_public_path__ + "img/collectiongallery_naturalbeige@2x.af77fce.webp";